import React from "react";
import ReactDOM from "react-dom";
import App from "./apps/App";
import * as serviceWorker from "./serviceWorker";
import { ThemeProvider } from "bluejay-ui";
import theme from "./utils/theme";
import "react-day-picker/lib/style.css";
import "./languages/i18next";
import "./index.css";
import { BookingProvider } from "./contexts/BookingContext";
import "./utils/app/checkIfAppTypeIsSupported";


ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BookingProvider>
        <App />
      </BookingProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
